var _defs, _rect, _rect2, _path, _path2, _rect3, _path3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path4, _rect10;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "5DB72CCD-220D-4C0D-A6EB-9811054408F6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "17.357002%",
    y1: "-4.40461857%",
    x2: "82.642998%",
    y2: "104.404619%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.5,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.7,
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "UI-Kit",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CMHC_UI-Kit_Iconography",
    transform: "translate(-162.000000, -3507.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-microsoft-office-/-excel",
    transform: "translate(162.000000, 3507.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_142",
    transform: "translate(0.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ambient-2",
    transform: "translate(9.005629, 1.636364)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("image", {
    id: "Bitmap",
    style: {
      mixBlendMode: "multiply"
    },
    x: 0.867208672,
    y: 0.44,
    width: 28.4177611,
    height: 32.2036364,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABTCAYAAAA8/EEfAAAABGdBTUEAALGOfPtRkwAAAHhlWElmTU0AKgAAAAgABAEaAAUAAAABAAAAPgEbAAUAAAABAAAARgEoAAMAAAABAAIAAIdpAAQAAAABAAAATgAAAAAAAAEsAAAAAQAAASwAAAABAAOgAQADAAAAAQABAACgAgAEAAAAAQAAAEigAwAEAAAAAQAAAFMAAAAA0m2kYAAAAAlwSFlzAAAuIwAALiMBeKU/dgAAAllJREFUeAHtnMtKA0EURBMNCm5U0IWg3+HGnb8uiPoZKgqK4jK+YtVkepgJwQPunK4LRfd0DYF7qJ7s7nSxWEz6NVX1n2vZi8MQRNv4tJy3YGY635I2pVpAGcyX9C59roJqALVwtvXCoXQs7Uo1QCpw3tTvnfQkzfuQnBiXV8M5lc6kE8lJqqGcnFvpQrqSHqUPqalZmx7DcHIM51w6kgo8bUddn+ruoe3wXuuLmHRXrUDwdfK1cnIMZ0/akGqo77ZJ914+LV3fBZA/yN47SV4Np5aPtHvt9z7ou5aUiMHfKoCAWwAFEBAAOwkKICAAdhIUQEAA7CQogIAA2ElQAAEBsJOgAAICYCdBAQQEwE6CAggIgJ0EBRAQADsJCiAgAHYSFEBAAOwkKICAANhJUAABAbCToAACAmAnQQEEBMBOggIICICdBAUQEAA7CQogIAB2EhRAQADsJCiAgADYSVAAAQGwk6AAAgJgJ0EBBATAToICCAiAnQQFEBAAOwkKICAAdhIUQEAA7CQogIAA2ElQAAEBsJOgAAICYCdBAQQEwE6CAggIgJ0EBRAQALskyAMXPS6vmUapde3YTvit/2r/2nuZgudRnWUa5bP2O5Incw4mwul5bGU4c8k930lmYBZdzTyWU4MVnRy/cCntt+6B1gKwPRrd4ltjONeSezeD93WjSv2i55jeSK5X6Vga+7jSfjDcuxmYRVer04B9rWoZeOvr1f+0GM5g0K0pdYCaB901rb5WTk5N04CbP6f+1TIP1wDQ8kiHS1DlcfTrOjCl6bWAipl1MvkB/sZ/UtEkmBsAAAAASUVORK5CYII="
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 2.28476131,
    y: 0.62,
    width: 25.3658537,
    height: 29.5036364,
    rx: 0.85
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.12,
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(1.000625, 0.000000)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Bitmap",
    style: {
      mixBlendMode: "multiply"
    },
    x: 0.533666875,
    y: 0.309090909,
    width: 26.8167605,
    height: 30.6327273,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEQAAABPCAYAAABS1GNxAAAABGdBTUEAALGOfPtRkwAAAHhlWElmTU0AKgAAAAgABAEaAAUAAAABAAAAPgEbAAUAAAABAAAARgEoAAMAAAABAAIAAIdpAAQAAAABAAAATgAAAAAAAAEsAAAAAQAAFjgAAAATAAOgAQADAAAAAQABAACgAgAEAAAAAQAAAESgAwAEAAAAAQAAAE8AAAAARALk5AAAAAlwSFlzAAAuIwAALgoBPOOgnQAAAa9JREFUeAHt3LFNBDEQheE1QtomyK4JMjIaIqMAMgoiI6QCIi67IiBaZix79/RLNMD8lszeMyT+7i3htG3bFtchcHt8XJbW2hr5LnY+q6yfuOglipHPpc2GDIz7OHuOnShV1iUu+hL7o6MkyEA5xeFb7O/Y+R5V2Xnf99gPsdeJka/IY+yv2FUgru+ZKFmG0038yJWvyNN4Zq629v+dE2Q/qCbB+04QnpfNguCrF0QQCCDaEEEggGhDBIEAog0RBAKINkQQCCDaEEEggGhDBIEAog0RBAKINkQQCCDaEEEggGhDBIEAog0RBAKINkQQCCDaEEEggGhDBIEAog0RBAKINkQQCCDaEEEggGhDBIEAog0RBAKINkQQCCDaEEEggGhDBIEAog0RBAKINkQQCCDaEEEggGhDBIEAog0RBAKINkQQCCDaEEEggGhDBIEAog0RBAKINuQPkD7cLH7Xh5vhbyrE4/5jhln1sV05rizHlq199F9OeItJd+c4+Bx1yDFeifTf12xG3vvcHUZDrucg5sS7KjPNcuzfa2LE7vMQ91mIcdBXsQGRvSHZjHn/X7bRBPwo2jtNAAAAAElFTkSuQmCC"
  }), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 1.28413592,
    y: 0.62,
    width: 25.3658537,
    height: 29.5036364,
    rx: 0.85
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4319366,2.27272727 L12.7579737,2.27272727 C12.385071,2.2682917 12.0261203,2.41168469 11.7624188,2.67042973 C11.4987174,2.92917478 11.3525777,3.28137886 11.3569963,3.64727273 L11.3569963,9.63636364 L24.498645,9.63636364 L24.4319366,2.27272727 Z",
    id: "Path",
    fill: "#21A366",
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2386908,2.27272727 L24.4319366,2.27272727 L24.4319366,9.63636364 L36.6562435,9.63636364 L36.6562435,3.63090909 C36.6518467,3.26634874 36.5000212,2.91843664 36.2341728,2.66372261 C35.9683243,2.40900858 35.6102339,2.26836144 35.2386908,2.27272727 Z",
    id: "Path",
    fill: "#33C481",
    fillRule: "nonzero"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#107C41",
    fillRule: "nonzero",
    x: 24.4319366,
    y: 17,
    width: 12.2076298,
    height: 7.38
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4319366,24.38 L24.4319366,17 L11.290288,17 L11.290288,30.3690909 C11.2858693,30.7349848 11.432009,31.0871889 11.6957105,31.3459339 C11.9594119,31.6046789 12.3183626,31.7480719 12.6912654,31.7437363 L35.2386908,31.7437363 C35.6131072,31.7480102 35.9737248,31.6051257 36.2400579,31.3468728 C36.5063911,31.0886199 36.6562435,30.736496 36.6562435,30.3690909 L36.6562435,24.38 L24.4319366,24.38 Z",
    id: "Path",
    fill: "#185C37",
    fillRule: "nonzero"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#107C41",
    fillRule: "nonzero",
    x: 11.2903898,
    y: 9.62,
    width: 13.1582239,
    height: 7.38
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#21A366",
    fillRule: "nonzero",
    x: 24.4319366,
    y: 9.62,
    width: 12.2076298,
    height: 7.38
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ambient-3",
    transform: "translate(0.000000, 6.545455)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.48,
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("image", {
    id: "Bitmap",
    style: {
      mixBlendMode: "multiply"
    },
    x: 0.567021055,
    y: 0.145454545,
    width: 23.6147592,
    height: 23.1709091,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAABGdBTUEAALGOfPtRkwAAAHhlWElmTU0AKgAAAAgABAEaAAUAAAABAAAAPgEbAAUAAAABAAAARgEoAAMAAAABAAIAAIdpAAQAAAABAAAATgAAAAAAAAEsAAAAAQAAASwAAAABAAOgAQADAAAAAQABAACgAgAEAAAAAQAAADygAwAEAAAAAQAAADwAAAAA3rOtQAAAAAlwSFlzAAAuIwAALiMBeKU/dgAABLJJREFUaAXtmolu2zAQRJ3e932g//91RZui6X0mnUdr5BVNialjS1GrBbakeGkfZ+kUEI/Ozs5W/5Nd2wX2SLbLvH3OkVA7KXU0NC+ARcBY3yfDLmsZOpXn2YRe4AYWuCtyylh3cFPAR0jq+GlTpuch8CKwYIG0X1U9etyAqYAN+lux5Q78aR/01hkOsPRdl98IThvuzVA1KU85hgGKAQXoL/lP+Y/gPK/EUYTuADdpDAztN+W35Hfkd+W35bSxASgeldbjKGZlAQYW0K/yL8HJOtqL0C1wA+tzirIA3pc/bPyBSuDZBPqBjikd6+raq1lZFrW6KAnsJ/kH+Xs5MWHeGJfrVv3bAjctVhcVgQP2ufyZ/EnzzEZElfU4mhkAdb/LP8tP5Mdys8QzfYqQ8Tx7kMa3v8TsEqlLGj+SA/xK/kL+WH5PDjBzUfWQymr5jgHsdAb4o/ydnHgxbwR9pDXPHYvAdKAwwAChJGn8VP5SDjR10pwXOKWnAEbFb3JSmSOGAYnibAIl8cHDBrFRyXJggmcgZ5SFUBlolCWt8amBCR7lALay1Eltsg+hSr8xam7yPvxgARxV9q80C+HAXgZgFCYLMZQlJv8l8XErZmCuMAtEaPrZLRZhN6MXF9SYQ5p/tADGOKeI4riIlZg7scUfrhzY55EygrOA3Qt6UXWNaj6PvN+xULpOhuJmUXVjDMrNsHkZF4p9+fwxnuP7Y1wR1GM68TDgPMbkaPlz7Bujbpi85N1uK8ZRA54arBj0RRprwBdZe4q5VYH+NeDqJi/A1S2a+YBF4ZkLWA1/Ubi6RTMfsCg8cwGr4S8KV7do5gMWhWcuYDX8ReHqFs18wKLwzAWshr8oXN2imQ9YFJ65gNXwF4WrW3S5B/gzTG+UNYWrC/SufEk7asAOOwfPnz1urJL3l5z3u70YS+ljWj7JcF4olsVFD9wY30+dL/z+yu+SEDyOems5sAe59GLxoojrLDL44ap9y/4qjssxcBOAOqXrjpmxW5YDMyAuyiJcD/LlL762+8v7FN+HY2xcc7ATF06cBvfY1dYtHhr0lVxjEyw75F1jERblkgjuCyR8eZ8SGCji4lIL7oss3Nvy7R0YWmjVk0WF3QkwOwUsN9xYjEtfXBbBeBEqTwVsQQz8VrFwdYlLLVxSA5r4DazqxiIwrUAzkAmGjfegWIzLI74lo2r5agEdBzDiAxiFEQQxiO+1/FiO2sSNynAwljmtRWAvxkCry675zNKG0qQ1wPxJq36P1Zh9GjHiBuaYESOwb+TEF4E7sOpLF0EobV6MHWIiC2A8s3tcR+TGDBsV/4YfGjwG7pQmC8k40pjYiDVXmJ+nOHcDTAfXEjUpprQe024Cz04a1uf30KC8Pxrx4U5rhACa+OycbTZjK53VtupcEA8X1AAibXHf0fJzhJ0CWCElGIQhtYED3M5zOr+5umrvAqeG9d8nQEhZ4EhfSpw2n92xYfXqZFbZ2QhcdJQtXg5ndkdhGrCgNFCGd92gLtOcEf8BFIvgTt/UVlJ2PaUHuO1cq82j4Vx6yNRlhO/8j6ovsKLCfYNpb9QfGjJK35CKQwH8NfDQYnPoi39L5xDvhWP8A026r3wLq0TdAAAAAElFTkSuQmCC"
  }), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 3.76902231,
    y: 2.15818182,
    width: 16.9105691,
    height: 16.5927273,
    rx: 0.85
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.24,
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(3.335418, 1.636364)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Bitmap",
    style: {
      mixBlendMode: "multiply"
    },
    x: 0,
    y: 0.0472727273,
    width: 18.011257,
    height: 17.6727273,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAuCAYAAABXuSs3AAAABGdBTUEAALGOfPtRkwAAAHhlWElmTU0AKgAAAAgABAEaAAUAAAABAAAAPgEbAAUAAAABAAAARgEoAAMAAAABAAIAAIdpAAQAAAABAAAATgAAAAAAAAzwAAAACwAADPAAAAALAAOgAQADAAAAAQABAACgAgAEAAAAAQAAAC6gAwAEAAAAAQAAAC4AAAAAGePEcgAAAAlwSFlzAAAuTgAALk4BHJw2GAAAAQJJREFUaAXtmbENwkAUQ+8QUpagS8cEdOzFAOxER5kF2CBDQHXYgUi4pbBykr/kXHyNraek+rW1VmqtQynlAPHc4rxQakZXnstUPFn2BF0glt/izCh1habf8iMubtATahsVu92hMzTwK+EcoQe01dJrL5Yn4JHFd3jpZeQ/7Km4AE5xwWEwIW6ALBEhLjgMJsQNkCUixAWHwYS4AbJEhLjgMJgQN0CWiBAXHAYT4gbIEhHigsNgQtwAWSJCXHAYTIgbIEtEiAsOgwlxA2SJCHHBYTAhboC8LGmRsyxpSVwuDAX+iWDHCeKSlsvasv++8ILTzWa5ctnZ5S5/XS9/gPfzfANxTodLWKK/ogAAAABJRU5ErkJggg=="
  }), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 0.433604336,
    y: 0.521818182,
    width: 16.9105691,
    height: 16.5927273,
    rx: 0.85
  })))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#107C41",
    fillRule: "nonzero",
    x: 3.76902231,
    y: 8.70363636,
    width: 16.9105691,
    height: 16.5927273,
    rx: 0.85
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 3.76902231,
    y: 0.407272727,
    width: 33.8211382,
    height: 33.1854545
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.13841985,21.5 L11.0902647,17 L8.38857619,12.5163636 L10.573275,12.5163636 L12.0408589,15.3636364 C12.1525432,15.5629484 12.2473651,15.7709194 12.3243694,15.9854545 L12.3243694,15.9854545 C12.4165948,15.7665711 12.522415,15.5534438 12.6412341,15.3472727 L14.3089431,12.5 L16.3101939,12.5 L13.4584115,17 L16.3101939,21.5327273 L14.1755264,21.5327273 L12.5078174,18.3745455 C12.4190175,18.2472497 12.3462223,18.1098902 12.2910152,17.9654545 L12.2910152,17.9654545 C12.2355708,18.1068529 12.1686475,18.2436559 12.0908901,18.3745455 L10.3231186,21.5327273 L8.13841985,21.5 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.5,
    style: {
      mixBlendMode: "soft-light"
    },
    transform: "translate(3.335418, 8.181818)",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero"
  }, _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.433604336,
    y: 0.521818182,
    width: 16.9105691,
    height: 16.5927273,
    rx: 0.85
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/Excel.6b8efe274355e7e525574a57178daefa.svg";
export { ForwardRef as ReactComponent };